import { ISettingElementV1, ISettingValueV1 } from '../models/AndromeTV.types';
import { Backend } from '../Backend';

export class DeviceSettingsApi {
  /**
   * Retrieve all device settings from the backend
   */
  static list(backend: Backend, device: string): Promise<ISettingElementV1[]> {
    const url = backend.makeUrl(`history/v1/settings/${encodeURIComponent(device)}`);
    return backend.getJson(url, backend.bearer) as Promise<ISettingElementV1[]>;
  }

  /**
   * Retrieve the value for the specified device setting
   */
  static value(backend: Backend, device: string, name: string): Promise<ISettingValueV1> {
    const url = backend.makeUrl(`history/v1/settings/${encodeURIComponent(device)}/${encodeURIComponent(name)}`);
    return backend.getJson(url, backend.bearer) as Promise<ISettingValueV1>;
  }

  /**
   * Create or update the value for the specified device setting
   */
  static update(backend: Backend, device: string, name: string, value: string): Promise<ISettingValueV1> {
    const url = backend.makeUrl(`history/v1/settings/${encodeURIComponent(device)}/${encodeURIComponent(name)}`);
    return backend.putJson(url, { value: value }, backend.bearer) as Promise<ISettingValueV1>;
  }

  /**
   * Delete the value for the specified device setting
   */
  static delete(backend: Backend, device: string, name: string): Promise<unknown> {
    const url = backend.makeUrl(`history/v1/settings/${encodeURIComponent(device)}/${encodeURIComponent(name)}`);
    return backend.delete(url, backend.bearer);
  }
}
